import { QesIcons } from "./qesIcons";
import { IconStorage } from "./interfaces";

// font awesome imports
import { angleDoubleRight, angleDoubleUp } from "./icon-data/font-awesome/angleDouble";
import { archive } from "./icon-data/font-awesome/archive";
import { arrowDown, arrowLeft, arrowRight, arrowUp, arrows, arrowsHorizontal, arrowsVertical } from "./icon-data/font-awesome/arrow";
import { ban } from "./icon-data/font-awesome/ban";
import { bank } from "./icon-data/font-awesome/bank";
import { barChart } from "./icon-data/font-awesome/barChart";
import { binoculars } from "./icon-data/font-awesome/binoculars";
import { book } from "./icon-data/font-awesome/book";
import { briefcase } from "./icon-data/font-awesome/briefcase";
import { building } from "./icon-data/font-awesome/building";
import { bullseye } from "./icon-data/font-awesome/bullseye";
import { calendar } from "./icon-data/font-awesome/calendar";
import { caretDown, caretRight, caretUp } from "./icon-data/font-awesome/caret";
import { chain } from "./icon-data/font-awesome/chain";
import { check, checkCircle, checkSquare, checkSquareOutline } from "./icon-data/font-awesome/check";
import { chevronDown, chevronRight } from "./icon-data/font-awesome/chevron";
import { circle, circleOutline, circleOutlineNotched, circleThin } from "./icon-data/font-awesome/circle";
import { clockOutline } from "./icon-data/font-awesome/clock";
import { clone } from "./icon-data/font-awesome/clone";
import { close } from "./icon-data/font-awesome/close";
import { cloudDownload } from "./icon-data/font-awesome/cloudDownload";
import { cog, cogs } from "./icon-data/font-awesome/cog";
import { copy } from "./icon-data/font-awesome/copy";
import { crosshairs } from "./icon-data/font-awesome/crosshairs";
import { database } from "./icon-data/font-awesome/database";
import { desktop } from "./icon-data/font-awesome/desktop";
import { dotCircleOutline } from "./icon-data/font-awesome/dotCircleOutline";
import { download, upload } from "./icon-data/font-awesome/download";
import { dragAndDropTexture } from "./icon-data/font-awesome/dragAndDropTexture";
import { edit } from "./icon-data/font-awesome/edit";
import { ellipsisVertical } from "./icon-data/font-awesome/ellipsisVertical";
import { envelope } from "./icon-data/font-awesome/envelope";
import { eraser } from "./icon-data/font-awesome/eraser";
import { exchange } from "./icon-data/font-awesome/exchange";
import { exclamationCircle, exclamationTriangle } from "./icon-data/font-awesome/exclamation";
import { externalLink } from "./icon-data/font-awesome/externalLink";
import { eye } from "./icon-data/font-awesome/eye";
import { fax } from "./icon-data/font-awesome/fax";
import { filePdfOutline, filesOutline, fileZipOutline } from "./icon-data/font-awesome/file";
import { filter } from "./icon-data/font-awesome/filter";
import { floppyDiskOutline } from "./icon-data/font-awesome/floppyDiskOutline";
import { folder } from "./icon-data/font-awesome/folder";
import { globe } from "./icon-data/font-awesome/globe";
import { history } from "./icon-data/font-awesome/history";
import { home } from "./icon-data/font-awesome/home";
import { idBadge } from "./icon-data/font-awesome/idBadge";
import { infoCircle } from "./icon-data/font-awesome/infoCircle";
import { laptop } from "./icon-data/font-awesome/laptop";
import { lineChart } from "./icon-data/font-awesome/lineChart";
import { list } from "./icon-data/font-awesome/list";
import { locationArrow } from "./icon-data/font-awesome/locationArrow";
import { lock, unlock } from "./icon-data/font-awesome/lock";
import { longArrowDown, longArrowUp } from "./icon-data/font-awesome/longArrow";
import { LowVision } from "./icon-data/font-awesome/lowVision";
import { map, mapMarker, mapPin } from "./icon-data/font-awesome/map";
import { minus, minusCircle } from "./icon-data/font-awesome/minus";
import { objectGroup } from "./icon-data/font-awesome/objectGroup";
import { pencil, pencilSquareOutline } from "./icon-data/font-awesome/pencil";
import { phone } from "./icon-data/font-awesome/phone";
import { play } from "./icon-data/font-awesome/play";
import { plug } from "./icon-data/font-awesome/plug";
import { plus, plusCircle } from "./icon-data/font-awesome/plus";
import { question, questionCircle } from "./icon-data/font-awesome/question";
import { refresh } from "./icon-data/font-awesome/refresh";
import { rocket } from "./icon-data/font-awesome/rocket";
import { search } from "./icon-data/font-awesome/search";
import { sellsy } from "./icon-data/font-awesome/sellsy";
import { server } from "./icon-data/font-awesome/server";
import { share } from "./icon-data/font-awesome/share";
import { signIn } from "./icon-data/font-awesome/signIn";
import { signOut } from "./icon-data/font-awesome/signOut";
import { sliders } from "./icon-data/font-awesome/sliders";
import { sort } from "./icon-data/font-awesome/sort";
import { spinner } from "./icon-data/font-awesome/spinner";
import { squareOutline } from "./icon-data/font-awesome/squareOutline";
import { star } from "./icon-data/font-awesome/star";
import { stop, stopCircle, stopCircleOutline } from "./icon-data/font-awesome/stop";
import { tag, tags } from "./icon-data/font-awesome/tag";
import { tasks } from "./icon-data/font-awesome/tasks";
import { thLarge } from "./icon-data/font-awesome/thLarge";
import { thumbsOutlineUp } from "./icon-data/font-awesome/thumbsOutlineUp";
import { times, timesCircle, timesCircleOutline, timesLight } from "./icon-data/font-awesome/times";
import { toggleOff, toggleOn } from "./icon-data/font-awesome/toggle";
import { trash, trashOutline } from "./icon-data/font-awesome/trash";
import { umbrella } from "./icon-data/font-awesome/umbrella";
import { university } from "./icon-data/font-awesome/university";
import { user, userMd, userPlus, userTimes, users } from "./icon-data/font-awesome/user";
import { wrench } from "./icon-data/font-awesome/wrench";

// untitled imports
import { circle as circleUntitled } from "./icon-data/untitled-ui/circle";
import { hexagonV1, hexagonV2 } from "./icon-data/untitled-ui/hexagon";
import { layers2v1, layers2v2, layers3v1, layers3v2 } from "./icon-data/untitled-ui/layers";
import { pentagon } from "./icon-data/untitled-ui/pentagon";
import { square } from "./icon-data/untitled-ui/square";
import { menuV1 } from "./icon-data/untitled-ui/menu";
import { databaseV1 } from "./icon-data/untitled-ui/database";
import { briefcaseV1 } from "./icon-data/untitled-ui/briefcase";
import { downloadCloudV2, downloadV1 } from "./icon-data/untitled-ui/download";
import { lifeBuoyV1 } from "./icon-data/untitled-ui/lifeBuoy";
import { presentationChartV1 } from "./icon-data/untitled-ui/presentationChart";
import { toolV1, toolV2 } from "./icon-data/untitled-ui/tool";
import { folder as folderUntitled } from "./icon-data/untitled-ui/folder";
import { dotsVertical } from "./icon-data/untitled-ui/dots";
import { pencilV1 } from "./icon-data/untitled-ui/pencil";
import { saveV1 } from "./icon-data/untitled-ui/save";
import { shareV4, shareV6 } from "./icon-data/untitled-ui/share";
import { trashV1 } from "./icon-data/untitled-ui/trash";
import { uploadV1 } from "./icon-data/untitled-ui/upload";
import { plus as plusUntitled, plusCircle as plusCircleUntitled } from "./icon-data/untitled-ui/plus";
import { archive as archiveUntitled } from "./icon-data/untitled-ui/archive";
import { x, xCircle, xClose } from "./icon-data/untitled-ui/x";
import { alignLeftV1, alignRightV1 } from "./icon-data/untitled-ui/align";
import { gridV1 } from "./icon-data/untitled-ui/grid";
import { expandV1 } from "./icon-data/untitled-ui/expand";
import { eyeOff } from "./icon-data/untitled-ui/eye";
import { phone as phoneUntitled } from "./icon-data/untitled-ui/phone";
import { printer } from "./icon-data/untitled-ui/printer";
import { refreshCcwV2 } from "./icon-data/untitled-ui/refresh";
import { searchSm } from "./icon-data/untitled-ui/search";
import { settingsV2 } from "./icon-data/untitled-ui/settings";
import { switchHorizontalV1, switchVerticalV1 } from "./icon-data/untitled-ui/switch";
import { zap } from "./icon-data/untitled-ui/zap";
import { eye as eyeUntitled } from "./icon-data/untitled-ui/eye";
import { list as listUntitled } from "./icon-data/untitled-ui/list";
import { buildingV7 } from "./icon-data/untitled-ui/building";
import { copyV7 } from "./icon-data/untitled-ui/copy";
import { rocketV2 } from "./icon-data/untitled-ui/rocket";
import { route } from "./icon-data/untitled-ui/route";
import { userV1 } from "./icon-data/untitled-ui/user";
import { usersV1 } from "./icon-data/untitled-ui/users";
import { filterLines } from "./icon-data/untitled-ui/filter";
import { slidersV4 } from "./icon-data/untitled-ui/sliders";
import { alertHexagon, alertTriangle } from "./icon-data/untitled-ui/alert";
import { arrowNarrowDown, arrowNarrowRight, arrowNarrowUp } from "./icon-data/untitled-ui/arrow";
import { chevronDown as chevronDownUntitled, chevronRight as chevronRightUntitled, chevronLeft, chevronUp, chevronRightDouble, chevronUpDouble } from "./icon-data/untitled-ui/chevron";
import { flagV1 } from "./icon-data/untitled-ui/flag";
import { glassesV2 } from "./icon-data/untitled-ui/glasses";
import { loadingV1 } from "./icon-data/untitled-ui/loading";
import { terminalBrowser } from "./icon-data/untitled-ui/terminal";
import { infoCircle as infoCircleUntitled } from "./icon-data/untitled-ui/info";
import { check as checkUntitled, checkCircle as checkCircleUntitled, checkSquareBroken } from "./icon-data/untitled-ui/check";
import { slashCircle, slashOctagon } from "./icon-data/untitled-ui/slash";
import { targetV2, targetV4 } from "./icon-data/untitled-ui/target";
import { scissorsV2 } from "./icon-data/untitled-ui/scissors";
import { bank as bankUntitled } from "./icon-data/untitled-ui/bank";
import { clock, clockRewind } from "./icon-data/untitled-ui/clock";
import { editV5 } from "./icon-data/untitled-ui/edit";
import { eraser as eraserUntitled } from "./icon-data/untitled-ui/eraser";
import { help, helpCircle } from "./icon-data/untitled-ui/help";
import { homeV3 } from "./icon-data/untitled-ui/home";
import { laptopV2 } from "./icon-data/untitled-ui/laptop";
import { linkV4 } from "./icon-data/untitled-ui/link";
import { mailV1 } from "./icon-data/untitled-ui/mail";
import { mapV1 } from "./icon-data/untitled-ui/map";
import { markerPinV6 } from "./icon-data/untitled-ui/markerPin";
import { minus as minusUntitled, minusCircle as minusCircleUntitled } from "./icon-data/untitled-ui/minus";
import { monitorV5 } from "./icon-data/untitled-ui/monitor";
import { play as playUntitled } from "./icon-data/untitled-ui/play";
import { logInV1 } from "./icon-data/untitled-ui/logIn";
import { logOutV1 } from "./icon-data/untitled-ui/logOut";
import { starV1 } from "./icon-data/untitled-ui/star";
import { stop as stopUntitled, stopCircle as stopCircleUntitled } from "./icon-data/untitled-ui/stop";
import { tagV1, tagV3 } from "./icon-data/untitled-ui/tag";
import { thumbsUp } from "./icon-data/untitled-ui/thumbsUp";
import { toggleV1Left, toggleV1Right } from "./icon-data/untitled-ui/toggle";
import { umbrellaV2 } from "./icon-data/untitled-ui/umbrella";
import { lineChartUpV2 } from "./icon-data/untitled-ui/lineChart";

const iconLookupFontAwesome = new Map<string, IconStorage>([
  [QesIcons.FontAwesome.AngleDoubleRight, angleDoubleRight],
  [QesIcons.FontAwesome.AngleDoubleUp, angleDoubleUp],
  [QesIcons.FontAwesome.Archive, archive],
  [QesIcons.FontAwesome.ArrowDown, arrowDown],
  [QesIcons.FontAwesome.ArrowLeft, arrowLeft],
  [QesIcons.FontAwesome.ArrowRight, arrowRight],
  [QesIcons.FontAwesome.ArrowUp, arrowUp],
  [QesIcons.FontAwesome.Arrows, arrows],
  [QesIcons.FontAwesome.ArrowsHorizontal, arrowsHorizontal],
  [QesIcons.FontAwesome.ArrowsVertical, arrowsVertical],
  [QesIcons.FontAwesome.Ban, ban],
  [QesIcons.FontAwesome.Bank, bank],
  [QesIcons.FontAwesome.BarChart, barChart],
  [QesIcons.FontAwesome.Binoculars, binoculars],
  [QesIcons.FontAwesome.Book, book],
  [QesIcons.FontAwesome.Briefcase, briefcase],
  [QesIcons.FontAwesome.Building, building],
  [QesIcons.FontAwesome.Bullseye, bullseye],
  [QesIcons.FontAwesome.Calendar, calendar],
  [QesIcons.FontAwesome.CaretDown, caretDown],
  [QesIcons.FontAwesome.CaretRight, caretRight],
  [QesIcons.FontAwesome.CaretUp, caretUp],
  [QesIcons.FontAwesome.Chain, chain],
  [QesIcons.FontAwesome.Check, check],
  [QesIcons.FontAwesome.CheckCircle, checkCircle],
  [QesIcons.FontAwesome.CheckSquare, checkSquare],
  [QesIcons.FontAwesome.CheckSquareOutline, checkSquareOutline],
  [QesIcons.FontAwesome.ChevronDown, chevronDown],
  [QesIcons.FontAwesome.ChevronRight, chevronRight],
  [QesIcons.FontAwesome.Circle, circle],
  [QesIcons.FontAwesome.CircleOutline, circleOutline],
  [QesIcons.FontAwesome.CircleOutlineNotched, circleOutlineNotched],
  [QesIcons.FontAwesome.CircleThin, circleThin],
  [QesIcons.FontAwesome.ClockOutline, clockOutline],
  [QesIcons.FontAwesome.Clone, clone],
  [QesIcons.FontAwesome.Close, close],
  [QesIcons.FontAwesome.CloudDownload, cloudDownload],
  [QesIcons.FontAwesome.Cog, cog],
  [QesIcons.FontAwesome.Cogs, cogs],
  [QesIcons.FontAwesome.Copy, copy],
  [QesIcons.FontAwesome.Crosshairs, crosshairs],
  [QesIcons.FontAwesome.Database, database],
  [QesIcons.FontAwesome.Desktop, desktop],
  [QesIcons.FontAwesome.DotCircleOutline, dotCircleOutline],
  [QesIcons.FontAwesome.Download, download],
  [QesIcons.FontAwesome.DragAndDropTexture, dragAndDropTexture],
  [QesIcons.FontAwesome.Edit, edit],
  [QesIcons.FontAwesome.EllipsisVertical, ellipsisVertical],
  [QesIcons.FontAwesome.Envelope, envelope],
  [QesIcons.FontAwesome.Eraser, eraser],
  [QesIcons.FontAwesome.Exchange, exchange],
  [QesIcons.FontAwesome.ExclamationCircle, exclamationCircle],
  [QesIcons.FontAwesome.ExclamationTriangle, exclamationTriangle],
  [QesIcons.FontAwesome.ExternalLink, externalLink],
  [QesIcons.FontAwesome.Eye, eye],
  [QesIcons.FontAwesome.Fax, fax],
  [QesIcons.FontAwesome.FilePdfOutline, filePdfOutline],
  [QesIcons.FontAwesome.FileZipOutline, fileZipOutline],
  [QesIcons.FontAwesome.FilesOutline, filesOutline],
  [QesIcons.FontAwesome.Filter, filter],
  [QesIcons.FontAwesome.FloppyDiskOutline, floppyDiskOutline],
  [QesIcons.FontAwesome.Folder, folder],
  [QesIcons.FontAwesome.Globe, globe],
  [QesIcons.FontAwesome.History, history],
  [QesIcons.FontAwesome.Home, home],
  [QesIcons.FontAwesome.IdBadge, idBadge],
  [QesIcons.FontAwesome.InfoCircle, infoCircle],
  [QesIcons.FontAwesome.Laptop, laptop],
  [QesIcons.FontAwesome.LineChart, lineChart],
  [QesIcons.FontAwesome.List, list],
  [QesIcons.FontAwesome.LocationArrow, locationArrow],
  [QesIcons.FontAwesome.Lock, lock],
  [QesIcons.FontAwesome.LongArrowDown, longArrowDown],
  [QesIcons.FontAwesome.LongArrowUp, longArrowUp],
  [QesIcons.FontAwesome.LowVision, LowVision],
  [QesIcons.FontAwesome.Map, map],
  [QesIcons.FontAwesome.MapMarker, mapMarker],
  [QesIcons.FontAwesome.MapPin, mapPin],
  [QesIcons.FontAwesome.Minus, minus],
  [QesIcons.FontAwesome.MinusCircle, minusCircle],
  [QesIcons.FontAwesome.ObjectGroup, objectGroup],
  [QesIcons.FontAwesome.Pencil, pencil],
  [QesIcons.FontAwesome.PencilSquareOutline, pencilSquareOutline],
  [QesIcons.FontAwesome.Phone, phone],
  [QesIcons.FontAwesome.Play, play],
  [QesIcons.FontAwesome.Plug, plug],
  [QesIcons.FontAwesome.Plus, plus],
  [QesIcons.FontAwesome.PlusCircle, plusCircle],
  [QesIcons.FontAwesome.Question, question],
  [QesIcons.FontAwesome.QuestionCircle, questionCircle],
  [QesIcons.FontAwesome.Refresh, refresh],
  [QesIcons.FontAwesome.Rocket, rocket],
  [QesIcons.FontAwesome.Search, search],
  [QesIcons.FontAwesome.Sellsy, sellsy],
  [QesIcons.FontAwesome.Server, server],
  [QesIcons.FontAwesome.Share, share],
  [QesIcons.FontAwesome.SignIn, signIn],
  [QesIcons.FontAwesome.SignOut, signOut],
  [QesIcons.FontAwesome.Sliders, sliders],
  [QesIcons.FontAwesome.Sort, sort],
  [QesIcons.FontAwesome.Spinner, spinner],
  [QesIcons.FontAwesome.SquareOutline, squareOutline],
  [QesIcons.FontAwesome.Star, star],
  [QesIcons.FontAwesome.Stop, stop],
  [QesIcons.FontAwesome.StopCircle, stopCircle],
  [QesIcons.FontAwesome.StopCircleOutline, stopCircleOutline],
  [QesIcons.FontAwesome.Tag, tag],
  [QesIcons.FontAwesome.Tags, tags],
  [QesIcons.FontAwesome.Tasks, tasks],
  [QesIcons.FontAwesome.ThLarge, thLarge],
  [QesIcons.FontAwesome.ThumbsOutlineUp, thumbsOutlineUp],
  [QesIcons.FontAwesome.Times, times],
  [QesIcons.FontAwesome.TimesCircle, timesCircle],
  [QesIcons.FontAwesome.TimesCircleOutline, timesCircleOutline],
  [QesIcons.FontAwesome.TimesLight, timesLight],
  [QesIcons.FontAwesome.ToggleOff, toggleOff],
  [QesIcons.FontAwesome.ToggleOn, toggleOn],
  [QesIcons.FontAwesome.Trash, trash],
  [QesIcons.FontAwesome.TrashOutline, trashOutline],
  [QesIcons.FontAwesome.Umbrella, umbrella],
  [QesIcons.FontAwesome.University, university],
  [QesIcons.FontAwesome.Unlock, unlock],
  [QesIcons.FontAwesome.Upload, upload],
  [QesIcons.FontAwesome.User, user],
  [QesIcons.FontAwesome.UserMd, userMd],
  [QesIcons.FontAwesome.UserPlus, userPlus],
  [QesIcons.FontAwesome.Users, users],
  [QesIcons.FontAwesome.UserTimes, userTimes],
  [QesIcons.FontAwesome.Wrench, wrench],
]);

const iconLookupUntitled = new Map<string, IconStorage>([
  [QesIcons.Untitled.AlertHexagon, alertHexagon],
  [QesIcons.Untitled.AlertTriangle, alertTriangle],
  [QesIcons.Untitled.AlignLeftV1, alignLeftV1],
  [QesIcons.Untitled.AlignRightV1, alignRightV1],
  [QesIcons.Untitled.Archive, archiveUntitled],
  [QesIcons.Untitled.ArrowNarrowDown, arrowNarrowDown],
  [QesIcons.Untitled.ArrowNarrowUp, arrowNarrowUp],
  [QesIcons.Untitled.Briefcase, briefcaseV1],
  [QesIcons.Untitled.BuildingV7, buildingV7],
  [QesIcons.Untitled.CheckCircle, checkCircleUntitled],
  [QesIcons.Untitled.ChevronDown, chevronDownUntitled],
  [QesIcons.Untitled.ChevronLeft, chevronLeft],
  [QesIcons.Untitled.ChevronRight, chevronRightUntitled],
  [QesIcons.Untitled.ChevronUp, chevronUp],
  [QesIcons.Untitled.Circle, circleUntitled],
  [QesIcons.Untitled.CopyV7, copyV7],
  [QesIcons.Untitled.Database, databaseV1],
  [QesIcons.Untitled.DotsVertical, dotsVertical],
  [QesIcons.Untitled.Download, downloadV1],
  [QesIcons.Untitled.ExpandV1, expandV1],
  [QesIcons.Untitled.Eye, eyeUntitled],
  [QesIcons.Untitled.EyeOff, eyeOff],
  [QesIcons.Untitled.FilterLines, filterLines],
  [QesIcons.Untitled.FlagV1, flagV1],
  [QesIcons.Untitled.Folder, folderUntitled],
  [QesIcons.Untitled.GlassesV2, glassesV2],
  [QesIcons.Untitled.GridV1, gridV1],
  [QesIcons.Untitled.HexagonOnEdge, hexagonV2],
  [QesIcons.Untitled.HexagonOnVertex, hexagonV1],
  [QesIcons.Untitled.InfoCircle, infoCircleUntitled],
  [QesIcons.Untitled.LayersThreeV1, layers3v1],
  [QesIcons.Untitled.LayersThreeV2, layers3v2],
  [QesIcons.Untitled.LayersTwoV1, layers2v1],
  [QesIcons.Untitled.LayersTwoV2, layers2v2],
  [QesIcons.Untitled.LifeBuoyV1, lifeBuoyV1],
  [QesIcons.Untitled.List, listUntitled],
  [QesIcons.Untitled.LoadingV1, loadingV1],
  [QesIcons.Untitled.MenuV1, menuV1],
  [QesIcons.Untitled.PencilV1, pencilV1],
  [QesIcons.Untitled.Pentagon, pentagon],
  [QesIcons.Untitled.PhoneV1, phoneUntitled],
  [QesIcons.Untitled.Plus, plusUntitled],
  [QesIcons.Untitled.PresentationChartV1, presentationChartV1],
  [QesIcons.Untitled.Printer, printer],
  [QesIcons.Untitled.RefreshCcwV2, refreshCcwV2],
  [QesIcons.Untitled.RocketV2, rocketV2],
  [QesIcons.Untitled.Route, route],
  [QesIcons.Untitled.SaveV1, saveV1],
  [QesIcons.Untitled.ScissorsV2, scissorsV2],
  [QesIcons.Untitled.SearchSm, searchSm],
  [QesIcons.Untitled.SettingsV2, settingsV2],
  [QesIcons.Untitled.ShareV4, shareV4],
  [QesIcons.Untitled.ShareV6, shareV6],
  [QesIcons.Untitled.SlashOctagon, slashOctagon],
  [QesIcons.Untitled.SlidersV4, slidersV4],
  [QesIcons.Untitled.Square, square],
  [QesIcons.Untitled.SwitchHorizontalV1, switchHorizontalV1],
  [QesIcons.Untitled.SwitchVerticalV1, switchVerticalV1],
  [QesIcons.Untitled.TargetV4, targetV4],
  [QesIcons.Untitled.TerminalBrowser, terminalBrowser],
  [QesIcons.Untitled.ToolV2, toolV2],
  [QesIcons.Untitled.TrashV1, trashV1],
  [QesIcons.Untitled.UploadV1, uploadV1],
  [QesIcons.Untitled.UsersV1, usersV1],
  [QesIcons.Untitled.UserV1, userV1],
  [QesIcons.Untitled.X, x],
  [QesIcons.Untitled.XClose, xClose],
  [QesIcons.Untitled.Zap, zap],

  [QesIcons.Untitled.ArrowNarrowRight, arrowNarrowRight],
  [QesIcons.Untitled.Bank, bankUntitled],
  [QesIcons.Untitled.Check, checkUntitled],
  [QesIcons.Untitled.CheckSquareBroken, checkSquareBroken],
  [QesIcons.Untitled.ChevronRightDouble, chevronRightDouble],
  [QesIcons.Untitled.ChevronUpDouble, chevronUpDouble],
  [QesIcons.Untitled.Clock, clock],
  [QesIcons.Untitled.ClockRewind, clockRewind],
  [QesIcons.Untitled.DownloadCloudV2, downloadCloudV2],
  [QesIcons.Untitled.EditV5, editV5],
  [QesIcons.Untitled.Eraser, eraserUntitled],
  [QesIcons.Untitled.Help, help],
  [QesIcons.Untitled.HelpCircle, helpCircle],
  [QesIcons.Untitled.HomeV3, homeV3],
  [QesIcons.Untitled.LaptopV2, laptopV2],
  [QesIcons.Untitled.LineChartUpV2, lineChartUpV2],
  [QesIcons.Untitled.LinkV4, linkV4],
  [QesIcons.Untitled.MailV1, mailV1],
  [QesIcons.Untitled.MapV1, mapV1],
  [QesIcons.Untitled.MarkerPinV6, markerPinV6],
  [QesIcons.Untitled.Minus, minusUntitled],
  [QesIcons.Untitled.MinusCircle, minusCircleUntitled],
  [QesIcons.Untitled.MonitorV5, monitorV5],
  [QesIcons.Untitled.Play, playUntitled],
  [QesIcons.Untitled.PlusCircle, plusCircleUntitled],
  [QesIcons.Untitled.LogInV1, logInV1],
  [QesIcons.Untitled.LogOutV1, logOutV1],
  [QesIcons.Untitled.SlashCircle, slashCircle],
  [QesIcons.Untitled.StarV1, starV1],
  [QesIcons.Untitled.Stop, stopUntitled],
  [QesIcons.Untitled.StopCircle, stopCircleUntitled],
  [QesIcons.Untitled.TagV1, tagV1],
  [QesIcons.Untitled.TagV3, tagV3],
  [QesIcons.Untitled.TargetV2, targetV2],
  [QesIcons.Untitled.ThumbsUp, thumbsUp],
  [QesIcons.Untitled.ToggleV1Left, toggleV1Left],
  [QesIcons.Untitled.ToggleV1Right, toggleV1Right],
  [QesIcons.Untitled.ToolV1, toolV1],
  [QesIcons.Untitled.UmbrellaV2, umbrellaV2],
  [QesIcons.Untitled.xCircle, xCircle],
]);

export const iconLookup = new Map<string, IconStorage>([
  ...iconLookupFontAwesome,
  ...iconLookupUntitled,
]);